import React, { useMemo } from 'react'

import classnames from 'classnames'
import Immutable from 'immutable'

import { ImageCrop } from '@library/api-menu-experience/src/interfaces/recipe'

import GoustoImage from 'components/Image'

import { SoldOutOverlay } from '../../Recipe/SoldOutOverlay'
import { DetailViewType } from '../types'

import css from './DetailImage.css'

type DetailImageProps = {
  media: ImageCrop[]
  title?: string
  view?: DetailViewType
  mouseEnter?: () => void
  mouseLeave?: () => void
  maxMediaSize?: number | null
}

export const DetailImage = ({
  media,
  title = '',
  view = 'standard',
  mouseEnter = () => {},
  mouseLeave = () => {},
  maxMediaSize = null,
}: DetailImageProps) => {
  // Memoize the Immutable.js conversion to prevent re-creating it on every render.
  // Ideally GoustoImage should not use Immutable.js directly.
  const immutableMedia = useMemo(() => Immutable.fromJS(media), [media])

  return (
    <div
      className={classnames(
        { [css.large]: view === 'large' },
        { [css.standard]: view === 'standard' },
        css.placeholder,
      )}
      onMouseEnter={mouseEnter}
      onMouseLeave={mouseLeave}
      data-testid="detail-image"
    >
      {/* The SoldOutOverlay is shown only when media for the recipe exists. */}
      {media.length > 0 && <SoldOutOverlay />}
      {media.length > 0 && (
        <GoustoImage
          media={immutableMedia}
          title={title}
          maxMediaSize={maxMediaSize}
          className={css.recipeImg}
        />
      )}
    </div>
  )
}
